import { locales } from "./homepage-seo.ts";

const productRoutes = ["/", "/backtest", "/results", "/history", "/settings", "/pricing"];

export const OFFLINE_NAVIGATION_PATHS = [
  ...productRoutes,
  ...locales.flatMap((locale) => productRoutes.map((route) => (
    route === "/" ? `/${locale}` : `/${locale}${route}`
  ))),
];

const navigationPaths = new Set(OFFLINE_NAVIGATION_PATHS);

export function isOfflineProductPath(pathname: string): boolean {
  return navigationPaths.has(pathname.replace(/\/$/, "") || "/");
}

export function canRegisterOfflineShell(url: URL): boolean {
  const production = url.protocol === "https:"
    && ["backtest.click", "www.backtest.click"].includes(url.hostname)
    && !url.port;
  const local = ["http:", "https:"].includes(url.protocol)
    && ["localhost", "127.0.0.1", "[::1]"].includes(url.hostname);
  return (production || local)
    && !url.username && !url.password && !url.search && !url.hash
    && isOfflineProductPath(url.pathname);
}
